"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "formContainer__Wrapper",
  componentId: "sc-kttobj-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    ", ";\n    @media (max-width: 860px) { \n        padding: 50px 10px 10px;\n        align-items: start;\n    }\n"])), function (props) {
  return props.color || _constants.COLORS.white;
}, _constants.FONTS.S);

var Container = _styledComponents["default"].div.withConfig({
  displayName: "formContainer__Container",
  componentId: "sc-kttobj-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: #fff;\n    max-width:  ", ";\n    width: ", ";\n    padding: 50px 50px;\n    //margin: 50px;\n    //box-shadow: 0px 15px 80px rgba(0, 0, 0, 0.04);\n    @media (max-width: 640px) {\n        padding: 30px 20px;\n        margin: 10px;\n    }\n"])), function (props) {
  return props.maxWidth || '550px';
}, function (props) {
  return props.width || 'auto';
});

var FormContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FormContainer, _React$Component);

  var _super = _createSuper(FormContainer);

  function FormContainer() {
    _classCallCheck(this, FormContainer);

    return _super.apply(this, arguments);
  }

  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          backgroundColor = _this$props.backgroundColor,
          maxWidth = _this$props.maxWidth,
          width = _this$props.width,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        "data-test": 'wrapper',
        color: backgroundColor
      }, /*#__PURE__*/_react["default"].createElement(Container, {
        "data-test": 'container',
        maxWidth: maxWidth,
        width: width,
        className: className
      }, children));
    }
  }]);

  return FormContainer;
}(_react["default"].Component);

exports["default"] = FormContainer;